export default (function (object) {
  return function (style) {
    if (typeof object === 'function') {
      return object(style);
    }

    return object[style];
  };
});


//////////////////
// WEBPACK FOOTER
// ./~/draft-convert/esm/util/styleObjectFunction.js
// module id = 1385
// module chunks = 1